module.exports = __webpack_public_path__ + "static/media/Chat-with-us-on-Whatsapp.9a9c4b3f.png";